import React from 'react';
import { Helmet } from 'react-helmet';
import { Briefcase, Code, Smartphone, TrendingUp, ArrowRight} from "lucide-react"; // example icons

const Dataanalyticsservices = () => {
  return (
    <section className="tech-services-section">
      {/* ✅ SEO Meta Tags */}
      <Helmet>
        <title>Data & Analytics Services | Pravisht Digital</title>
        <meta
          name="description"
          content="Explore Pravisht's end-to-end Data & Analytics services including big data engineering, predictive modelling, BI dashboards and governance solutions."
        />
        <meta
          name="keywords"
          content="Data Analytics, Big Data, Machine Learning, Business Intelligence, Data Science, Pravisht"
        />
        <meta property="og:title" content="Data & Analytics Services | Pravisht Digital" />
        <meta property="og:description" content="We deliver scalable, intelligent data solutions that unlock insights and drive business value." />
        <meta property="og:image" content="/data_analysis_pravisht.jpg" />
        <meta property="og:type" content="website" />
        <meta name="author" content="Pravisht Digital" />
      </Helmet>
      <div className="breadcrumb">
        <a href="/" className="mx-1">Home</a> &gt; <span className="mx-1">Data &amp; Analytics Services</span>
      </div>

      <div className="about-heading-section">
        <h1>Data &amp; Analytics Services</h1>
        <p>
          At Pravisht, we specialise in end-to-end technology solutions that drive digital transformation across industries. Our integrated approach combines application development, consulting, automation, and platform engineering to help enterprises evolve, scale, and stay future-ready.
        </p>
      </div>

      <div className="about-image-fullscreen">
        <img src="/data_analysis_pravisht.jpg" alt="Pravisht Digital" />
      </div>

      {/* New Section: Data & Analytics Services */}
      <div className="core-offerings">
        <div className="how-we-help__content">
          <p className="how-we-help__description services-desc">Our Services</p>
          <h1 className="how-we-help__title">Data &amp; Analytics Services</h1>
          <hr className="portfolio-horizontalline" />
        </div>

        <div className="about-heading-section">
          <p>
            At Pravisht, we help organisations unlock the true value of their data through end-to-end analytics, from big data engineering to advanced data science, prescriptive modelling, and real-time insights. Our solutions are designed to deliver business impact through intelligence, automation, and governance.
          </p>
        </div>

        <div className="offerings-grid">
          <div className="offering-card app-dev-card">
            <h4>1. Big Data Engineering</h4>
            <p>Transform raw data into actionable intelligence with high-performance big data solutions:</p>
            <ul>
              <li>Parallel Processing &amp; In-memory Solutions</li>
              <li>Real-time Data Streaming Architectures</li>
              <li>Custom Machine Learning Algorithms</li>
            </ul>
          </div>

          <div className="offering-card consulting-card">
            <h4>2. Enterprise Data Strategy</h4>
            <p>A robust data foundation starts here:</p>
            <ul>
              <li>Data Governance &amp; Quality Management</li>
              <li>Multi-Dimensional Data Modelling</li>
              <li>ETL, ODS, Data Marts, and Migration Services</li>
            </ul>
          </div>

          <div className="offering-card iot-blockchain-card">
            <h4>3. Predictive &amp; Prescriptive Modelling</h4>
            <p>Future-proof your business with data science:</p>
            <ul>
              <li>Predictive, Prescriptive &amp; Cognitive Modelling</li>
              <li>Machine Learning, Forecasting &amp; Optimisation</li>
              <li>Quantitative &amp; Behavioural Models</li>
            </ul>
          </div>

          <div className="offering-card automation-card">
            <h4>4. Business Intelligence &amp; Analytics</h4>
            <p>Convert data into enterprise-wide insights:</p>
            <ul>
              <li>Real-Time and Aggregated CUBE-based Analytics</li>
              <li>Custom Dashboards, Query Builder &amp; Ad-hoc Reporting</li>
              <li>Metadata-driven Reporting Systems</li>
            </ul>
          </div>

          <div className="offering-card mobile-apps-card">
            <h4>5. Other Data Offerings</h4>
            <p>Support and scale your analytics journey:</p>
            <ul>
              <li>Analytics Advisory &amp; Strategy</li>
              <li>Business Value Analytics</li>
              <li>Data Security &amp; Privacy Consulting</li>
            </ul>
          </div>
        </div>
        </div>

        <div className="engagement-layers-and-why-choose" style={{ backgroundColor: '#f1f4f3' }}>
        <h3 className="section-subtitle">Our Engagement Lifecycle</h3>
        <p>We work across four interconnected phases to deliver consistent, value-driven data outcomes:</p>
        <div className="bottom-sections-grid">
          <div className="how-we-help__cards">
            {[
              { icon: <Briefcase size={40} />, title: "Assessment", desc: "Understand your data maturity, infrastructure, and pain points" },
              { icon: <Code size={40} />, title: "Analysis", desc: "Model, clean, and structure your data assets" },
              { icon: <Smartphone size={40} />, title: "Development", desc: "Build and deploy scalable, intelligent data platforms" },
              { icon: <TrendingUp size={40} />, title: "Maintenance", desc: "Ensure ongoing data quality, compliance, and operational efficiency" }
            ].map((card, i) => (
              <div className="how-we-help__card" key={i} style={{ height: '190px', cursor: 'default' }}>
                <h3 className="card-title">{card.title}</h3>
                <p className="card-desc">{card.desc}</p>
              </div>
            ))}
          </div>
        </div>
       </div>
    </section>
  );
};

export default Dataanalyticsservices;
